import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { color, size } from '../styles/helpers/variables';
import { SlideIn, FadeIn } from '../styles/helpers/animations';

class SlideOutContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      scrollPosition: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.active === false && nextProps.active === true) {
      this.setState({ scrollPosition: window.pageYOffset });
      this.activate(window.pageYOffset);
    } else if (this.props.active === true && nextProps.active === false) {
      this.deactivate(this.state.scrollPosition);
    }
  }

  activate(scrollPosition) {
    document.body.style.position = 'fixed';
    document.body.style.left = 0;
    document.body.style.right = 0;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.overflowY = 'scroll';
    this.setState({ isOpen: true });
  }

  deactivate(scrollPosition) {
    this.setState({ isOpen: false });
    document.body.removeAttribute('style');
    window.scrollTo(0, scrollPosition);
  }

  render() {
    return (
      <Container active={this.props.active} top={this.props.top} small={this.props.small && !this.state.scrollPosition}>
        <FadeIn in={this.state.isOpen}>
          <Overlay onClick={() => this.props.toggleModal(false)} active={this.props.active} />
        </FadeIn>
        <SlideIn
          in={this.state.isOpen}
          translateX={this.props.fromLeft ? '-100%' : '100%'}
          small={this.props.small && !this.state.scrollPosition}
        >
          <SlideOut
            fromLeft={this.props.fromLeft}
            bgColor={this.props.bgColor}
            small={this.props.small}
            notScrolled={!this.state.scrollPosition}
            noPadding={this.props.noPadding}
          >
            <CloseButton onClick={() => this.props.toggleModal(false)} />
            {this.props.children}
          </SlideOut>
        </SlideIn>
      </Container>
    );
  }
}

const Container = styled.div`
  position: fixed;
  top: ${props => (props.top ? `${props.top}px` : 0)};
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 200;
  pointer-events: ${props => (props.active ? 'auto' : 'none')};

  ${'' /* ${props =>
    props.small &&
    css`
      top: ${header.logoAreaMobileHeight - 1}px;

      @media screen and (min-width: ${size.xLarge}px) {
        top: ${header.logoAreaDesktopHeight - 1}px;
      }
    `}; */}
`;

const CloseButton = styled.button`
  height: 44px;
  width: 44px;
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background-color: transparent;
  background-image: url('/images/icons/close.svg');
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-size: 14px;
  font-size: 20px;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${color.black};
  transition: opacity 0.8s linear;
  opacity: 0.2;
  cursor: inherit;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

const SlideOut = styled.div`
  height: 100vh;
  width: 85vw;
  max-width: 400px;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${props => (props.bgColor ? props.bgColor : color.white)};
  padding: ${props => (props.small ? '20px 15px 126px 22px' : '26px 30px 126px 22px')};
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0);

  @media screen and (min-width: ${size.xLarge}px) {
    max-width: 560px;
    padding: 42px 37px 26px 45px;
  }

  ${'' /* ${props =>
    props.notScrolled &&
    props.small &&
    css`
      height: calc(100vh - ${header.logoAreaMobileHeight - 1}px);

      @media screen and (min-width: ${size.xLarge}px) {
        height: calc(100vh - ${header.logoAreaDesktopHeight - 1}px);
      }
    `}; */}

  ${props =>
    props.fromLeft &&
    css`
      right: initial;
      left: 0;
    `};

  ${props =>
    props.active &&
    css`
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
    `};

  ${props =>
    props.small &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    `};

  ${props =>
    props.noPadding &&
    css`
      padding: 0 !important;
    `};
`;

SlideOutContainer.defaultProps = {
  active: false,
  fromLeft: false,
  top: null,
  small: false,
  bgColor: null,
  noPadding: false,
  toggleModal: () => {}
};

SlideOutContainer.propTypes = {
  top: PropTypes.number,
  small: PropTypes.bool,
  bgColor: PropTypes.string,
  noPadding: PropTypes.bool,
  active: PropTypes.bool,
  toggleModal: PropTypes.func,
  fromLeft: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default SlideOutContainer;



// WEBPACK FOOTER //
// ./src/components/SlideOutContainer.js